import { Injectable } from "@angular/core";
import { EmitterAction, Receiver } from "@ngxs-labs/emitter";
import { State, StateContext } from "@ngxs/store";
import { QuotationSearchFilter } from "src/app/@models/quotation/quotation-filter.model";

@State<QuotationSearchFilter >({
    name: 'quotationFilterState',
    defaults: new QuotationSearchFilter ()
})
@Injectable({
    providedIn: 'root'
})
export class QuotationFilterState {

    @Receiver()
    static setCurrentState(
        { setState }: StateContext<QuotationSearchFilter >,
        { payload }: EmitterAction<QuotationSearchFilter >
    ) {
        setState(payload)
    }

    @Receiver()
    static reset(
        { setState }: StateContext<QuotationSearchFilter >) {
         const newEntry = new QuotationSearchFilter();
                newEntry.isAll = false;
                newEntry.statusId = 0;
                setState(newEntry);
    }

}
